export function mapAddressToApiRequest(address) {
    return {
        type: address.type,
        addressLine: address.line1 ?? null,
        addressLine2: address.line2 ?? null,
        addressLine3: address.line3 ?? null,
        streetName: address.streetName ?? null,
        houseNumber: address.houseNumber ?? null,
        houseNumberSuffix: address.houseNumberSuffix ?? null,
        postalCode: address.postalCode ?? null,
        city: address.city ?? null,
        region: address.region ?? null,
        country: address.country ?? null,
        latitude: address.latitude ?? null,
        longitude: address.longitude ?? null,
        isPrimary: address.isPrimary,
    };
}
